import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import _ from 'lodash';
import { FormDialogComponent, FormDialogOption } from '../form-dialog/form-dialog.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
// import { UrlService } from 'src/app/services/url.service';



export interface SelectDialogOptions extends FormDialogOption {
    label: string;
    multiple?: boolean;
    data?: any[];
    defaultValue?: any;
    predicate?: (v: any) => boolean;
    display?: (v: any) => string;
    map?: (v: any) => any;
    order?: boolean;
}

@Component({
    selector: 'app-select-dialog',
    templateUrl: './select-dialog.component.html',
    styleUrls: ['./select-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectDialog extends FormDialogComponent implements OnInit {

    // get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }
    label: string = '';
    multiple: boolean = true;
    protected _data: any[] = [];
    get data(): any[] {
        return this._data.filter(this.predicate);
    }
    predicate: (v: any) => boolean;
    display: (v: any) => string;
    map: (v: any) => any;
    order: boolean = false;


    get isValid(): boolean { return this.form.valid; }

    constructor(
        protected fb: FormBuilder,
        protected dialogRef: MatDialogRef<FormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public config: SelectDialogOptions) {
        super(fb, dialogRef, config);

        // INIT FROM OPTIONS
        this.multiple = config.multiple || true;
        this.label = config.label || '';
        this._data = config.data || [];
        this.predicate = config.predicate || ((v: any) => true);
        this.display = config.display || ((v: any) => v);
        this.map = config.map || ((v: any) => v);
        this.order = config.order || false;

        this.form = this.fb.group({
            data: new FormControl(config.defaultValue || (this.multiple ? [] : null), [Validators.required]),
        });
    }

    drop(event: CdkDragDrop<any>) {
        moveItemInArray(this.controls['data'].value, event.previousIndex, event.currentIndex);
    }

    async ngOnInit() {

    }

    submit() {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }
}
